var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-loading-spinner", {
        attrs: {
          "is-initial-loading": _vm.isInitialLoading,
          "is-refresh-loading": _vm.isRefreshLoading,
        },
      }),
      _vm._v(" "),
      !_vm.isInitialLoading
        ? _c(
            "div",
            [
              _vm._m(0),
              _vm._v(" "),
              _c("hr", { staticClass: "separator separator--gray4 w-100" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "--bs-bg-opacity": "1",
                    "background-color":
                      "rgba(var(--bs-gray2-rgb), var(--bs-bg-opacity)) !important",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      ref: "cartContentContainer",
                      staticClass: "container-fluid",
                      attrs: { id: "cartContentContainer" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row py-2 py-md-3" },
                        [
                          _vm.cartItemsIsFilled
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-md-8 px-1" },
                                  [
                                    _c(
                                      "CartPageInternetMobileDevicePackContent",
                                      {
                                        attrs: {
                                          "internet-dto":
                                            _vm.cartData.filledInternetContent,
                                          "mobile-dto":
                                            _vm.cartData.filledMobileContent,
                                          "cross-sell-content":
                                            _vm.cartData.crossSellContent,
                                          "promotion-content":
                                            _vm.cartData.promotionContent,
                                          "total-discounts-label":
                                            _vm.cartData.totalDiscountsLabel,
                                          "device-dto":
                                            _vm.cartData.filledDeviceContent,
                                        },
                                        on: {
                                          "remove-item-from-cart-in-progress":
                                            function ($event) {
                                              return _vm.cartModificationInProgress(
                                                $event
                                              )
                                            },
                                          "remove-item-from-cart-success":
                                            function ($event) {
                                              return _vm.displayMessageAndRefresh(
                                                $event
                                              )
                                            },
                                          "remove-item-from-cart-error":
                                            function ($event) {
                                              return _vm.displayMessageAndRefresh(
                                                $event
                                              )
                                            },
                                          "sponsor-success": function ($event) {
                                            return _vm.onSponsorSuccess($event)
                                          },
                                        },
                                      }
                                    ),
                                    _vm._v(" "),
                                    _vm.cartData.filledDeviceContent &&
                                    !_vm.shouldShowDeviceInPack
                                      ? _c("CartPageDeviceContent", {
                                          attrs: {
                                            "device-dto":
                                              _vm.cartData.filledDeviceContent,
                                          },
                                          on: {
                                            "remove-item-from-cart-in-progress":
                                              function ($event) {
                                                return _vm.cartModificationInProgress(
                                                  $event
                                                )
                                              },
                                            "remove-item-from-cart-success":
                                              function ($event) {
                                                return _vm.displayMessageAndRefresh(
                                                  $event
                                                )
                                              },
                                            "remove-item-from-cart-error":
                                              function ($event) {
                                                return _vm.displayMessageAndRefresh(
                                                  $event
                                                )
                                              },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-md-4 mt-1 mt-md-0 px-1",
                                  },
                                  [
                                    _c("CartPageRecap", {
                                      attrs: { dto: _vm.cartData.recap },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.cartData.crossSellContent
                                  ? [
                                      _vm.cartData.crossSellContent
                                        .showNewDesign
                                        ? _c(
                                            "div",
                                            [
                                              _c("CartPageCrossSellContent", {
                                                attrs: {
                                                  dto: _vm.cartData
                                                    .crossSellContent,
                                                },
                                                on: {
                                                  "add-mobile-offer-in-progress":
                                                    function ($event) {
                                                      return _vm.cartModificationInProgress(
                                                        $event
                                                      )
                                                    },
                                                  "add-mobile-offer-success":
                                                    function ($event) {
                                                      return _vm.displayMessageAndRefresh(
                                                        $event
                                                      )
                                                    },
                                                  "add-mobile-offer-error":
                                                    function ($event) {
                                                      return _vm.displayMessageAndRefresh(
                                                        $event
                                                      )
                                                    },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c("div", [
                                            _vm._m(1),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 px-1",
                                                attrs: {
                                                  id: "cross-sell-content",
                                                },
                                              },
                                              [
                                                _c(
                                                  "CartPageCrossSellContentNonModal",
                                                  {
                                                    attrs: {
                                                      dto: _vm.cartData
                                                        .crossSellContent,
                                                    },
                                                    on: {
                                                      "add-mobile-offer-in-progress":
                                                        function ($event) {
                                                          return _vm.cartModificationInProgress(
                                                            $event
                                                          )
                                                        },
                                                      "add-mobile-offer-success":
                                                        function ($event) {
                                                          return _vm.displayMessageAndRefresh(
                                                            $event
                                                          )
                                                        },
                                                      "add-mobile-offer-error":
                                                        function ($event) {
                                                          return _vm.displayMessageAndRefresh(
                                                            $event
                                                          )
                                                        },
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                    ]
                                  : _vm._e(),
                              ]
                            : [
                                _c(
                                  "div",
                                  { staticClass: "col-12 px-1 mb-2" },
                                  [
                                    _c("CartPageEmptyContent", {
                                      attrs: {
                                        dto: _vm.cartPageDto.emptyContent,
                                        "shop-sosh": _vm.cartPageDto.shopSosh,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "separator separator--gray4 w-100" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bg-gray2" },
                [
                  _vm.cartLegalMentions
                    ? _c("CartLegalMentions", {
                        attrs: { "legal-mentions": _vm.cartLegalMentions },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.eChatButton && _vm.eChatButton.showEChatButton
                ? _c("EChatButton", {
                    attrs: {
                      id: _vm.eChatButton.id,
                      "is-bottom": _vm.eChatButton.isBottom,
                      section: _vm.eChatButton.section,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.cartPageDto.fiberStatusOverlay
        ? _c(
            "div",
            [
              _c("OverlayDialog", {
                attrs: {
                  id: "fiber-status-overlay",
                  "modal-button-label": "Fermer",
                  "action-label": "Ouvrir",
                  "is-auto-opened": true,
                  "tms-category":
                    _vm.cartPageDto.fiberStatusOverlay.tms.category,
                  "tms-label": _vm.cartPageDto.fiberStatusOverlay.tms.label,
                  "modal-title": _vm.cartPageDto.fiberStatusOverlay.title,
                  "modal-content": _vm.cartPageDto.fiberStatusOverlay.content,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "bg-dark" }, [
        _c("div", { staticClass: "container-fluid" }, [_vm._m(2)], 1),
      ]),
      _vm._v(" "),
      _c("ob1-snack-bar", {
        ref: "cartPageSnackbar",
        staticClass: "over-page-loading-spinner",
        attrs: {
          id: "cartPageSnackbar",
          icon: _vm.snackbarIcon,
          label: _vm.snackbarMessage,
        },
      }),
      _vm._v(" "),
      _vm.confirmationMessage
        ? _c("FeedbackModalDialog", {
            ref: "feedbackConfirmationDialog",
            attrs: {
              id: "cartConfirmationDialog",
              "modal-content": _vm.confirmationMessage.text,
              "modal-title": _vm.confirmationMessage.title,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "actionButton",
                  fn: function () {
                    return [
                      _c("Bouton", {
                        attrs: {
                          label: _vm.confirmationMessage.buttonLabel,
                          "is-primary": false,
                        },
                        on: { click: _vm.initConfirmationCart },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2511544569
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("CartPageHeader", { attrs: { title: _vm.cartPageDto.title } })
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 px-1 py-2" }, [
      _c("hr", { staticClass: "separator separator--gray4" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("OrangeCommitments", {
      attrs: { commitments: _vm.cartPageDto.commitments },
    })
  },
]
render._withStripped = true

export { render, staticRenderFns }